<template>
  <div class="print:hidden">
    <div class="flex items-center h-14 bg-white shadow w-full">
      <!-- actions wrapper - start -->
      <button
        @click="toggleShowMenu"
        class="ml-8 block xl:hidden outline-0"
        :class="{ 'ml-sidebar': showMenu === true }"
      >
        <i v-if="!showMenu" class="material-icons text-blue-dark m-0">
          menu
        </i>
        <i v-if="showMenu" class="material-icons text-blue-dark m-0">
          close
        </i>
      </button>
      <global-search class="ml-8"></global-search>
      <div class="flex items-center ml-auto mr-4">
        <button @click="$router.push(`/cart-edit`)">
          <icon name="shopping-cart" class="w-6 mr-4 text-grey-light" />
        </button>
        <NotificationSVG />

        <button
          class="flex items-center ml-3 cursor-pointer"
          @click="showAccountLinks = !showAccountLinks"
        >
          <div class="relative flex items-center">
            <img :src="user.gravatar" class="h-8 w-8 rounded-full" />
            <i class="material-icons text-blue-dark">
              keyboard_arrow_down
            </i>
            <on-click-outside
              v-if="showAccountLinks"
              :do="() => closeShowAccountLinks"
            >
              <div
                v-if="showAccountLinks"
                class="absolute p-2 mt-12 rounded-sm pin-r shadow bg-white text-left z-20"
              >
                <router-link
                  class="block p-1 px-3"
                  v-show="user.email == null"
                  to="/login"
                  >Login</router-link
                >
                <a
                  class="p-1 px-3 block"
                  v-show="user.email !== null"
                  @click.prevent="onLogout"
                  >Logout</a
                >
              </div>
            </on-click-outside>
          </div>
        </button>
      </div>
      <!-- actions wrapper - end -->
    </div>
  </div>
</template>

<script>
import GlobalSearch from '../global-search/GlobalSearch.vue';
import jwtDecode from 'jwt-decode';
import LoginService from '../../services/LoginService';
import NotificationSVG from './sidemenu/svgs/NotificationSVG.vue';
import CartNavbarSVG from '../Icons/CartNavbarSVG.vue';
import { mapState } from 'vuex';

export default {
  components: {
    GlobalSearch,
    NotificationSVG,
    CartNavbarSVG
  },
  created() {
    this.loginService = new LoginService();
  },
  computed: mapState({
    showMenu: state => state.showMenu,
    user: state => state.user
  }),
  data() {
    return {
      msg: 'Eros',
      showAccountLinks: false
    };
  },
  mounted() {
    let token = this.loginService.token;

    if (token) {
      let tokenPayload = jwtDecode(token);
      this.user.email = tokenPayload.email;
      this.user.gravatarUrl = tokenPayload.gravatar;
    }
  },
  methods: {
    onLogout() {
      this.loginService.logout();
      this.$store.commit('removeUser');

      this.$router.replace('/login');
    },
    toggleMenu() {
      this.$store.commit('toggleShowMenu');
    },
    closeShowAccountLinks() {
      this.showAccountLinks = false;
    },
    toggleShowMenu() {
      // this.showMenu = !this.showMenu
      this.$store.commit('toggleShowMenu');
    }
  }
};
</script>

<style>
.notification-badge {
  top: -18px;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?f02621a2